import { modelOptions, prop, Severity } from '@typegoose/typegoose';

@modelOptions({
  options: {allowMixed: Severity.ALLOW},
  schemaOptions: {_id: false}
})
class CategoryStateSpecificsModel {
  @prop({required: true})
  userProfilesCount: number;

  @prop({required: true})
  surfacePercentageReduction: number;
}

@modelOptions({
  options: {allowMixed: Severity.ALLOW},
  schemaOptions: {_id: false}
})
export class CategoryStateModel {
  @prop({required: true, type: CategoryStateSpecificsModel})
  active: CategoryStateSpecificsModel;

  @prop({required: true, type: CategoryStateSpecificsModel})
  inactive: CategoryStateSpecificsModel;
}
